module.exports = __webpack_public_path__ + "static/media/Heat_Block.f52ec9ff.svg";